import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
    }

    async duplicateLesson(event) {
        event.preventDefault();

        const lessonId = this.data.get("lessonId");
        const pupilId = this.data.get("pupilId");

        this.openQuicklook(pupilId, lessonId);
    }

    async openQuicklook(pupilId, lessonId) {
        const url = `/schools/lesson/add-lesson/quick-look?pupil_id=${pupilId}&duplicate_lesson_id=${lessonId}`;
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-CSRF-Token": csrfToken,
                Accept: "text/vnd.turbo-stream.html",
            },
        });

        if (response.ok) {
            const quickViewElement = document.querySelector(
                "#school-dashboard-lesson-quick-look"
            );
            quickViewElement.classList.remove("u-hidden");

            const responseBody = await response.text();
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(responseBody, "text/html");
            const template = xmlDoc.querySelector("template");
            const targetElement = document.getElementById("school_lesson_quick_look");

            if (template && targetElement) {
                targetElement.innerHTML = "";
                targetElement.appendChild(template.content.cloneNode(true));
            }
        }
    }
}